export type VerificationUser = {
  id?: string | null;
  email_verified?: boolean | null;
  email_verified_at?: string | null;
};

/**
 * Decide whether the join form should block before calling the organizer-access API.
 * A missing verification field is not proof that the email is unverified — the API is.
 * A 401 is never represented here.
 */
export function clientEmailVerificationBlock(
  user: VerificationUser | null | undefined,
): 'missing_user' | 'unverified' | null {
  if (!user?.id) return 'missing_user';

  if (user.email_verified === true) return null;
  if (user.email_verified === false) return 'unverified';

  if (Object.prototype.hasOwnProperty.call(user, 'email_verified_at')) {
    return user.email_verified_at ? null : 'unverified';
  }

  return null;
}
